export default () => ({

  updating: false,
  waitingForCallingUpdate: false,

  product: {},
  versionedProduct: {},
  productsSubmittedCount: 112,
  owner: {},

  emptyDamageDto: {},

  attributes: {},
  attributesDe: {},
  editing: undefined,

  panels: [],
  panelsEquipment: [],
  panelsImages: [],
  progressControlClass: undefined,

  progressSnackbar: false,
  progressSnackbarText: 'Sie haben es fast geschafft.',
  progressSnackbarTimeout: 10000,

  overlay: false,

  totalGalleryUpload: 0,
  doneGalleryUpload: 0,

  defectsDescriptionValid: false,

  onboardingStepperShowMyAdCard: false,
  onboardingStepperStatus: undefined,

  productTypeOptionIds: {
    motorhome: undefined,
    trailer: undefined
  },

  uploadingGalleryImages: false

})
